StepHandler = App.loadClass 'grower::handlers/placement/StepHandler'
ScrollHelper = App.load 'core::ScrollHelper'

class exports.SeedOptionsHandler extends StepHandler

    setInitialDeps: () ->
        super()
        @syncDeps
            'Seed_Options_Selections': 'grower::viewmodels/placement/seed_options/Selections'
            'Seed_Options_Form': 'grower::viewmodels/placement/seed_options/Form'


    # don't use the default afterLoadLayout
    afterLoadLayout: (selector, data) ->
        self = this

        @moveStepContent()
        @parent._handleResize()

        @msg = $(@parent.layoutSelector).find('.message_writer').message_writer(autoHide: false)

        # selections knockout
        @selectionsKO = new (@getDep 'Seed_Options_Selections')(this)
        ko.cleanNode $(@sidebar.layoutSelector).find('.spp-units-display')[0]
        ko.applyBindings @selectionsKO, $(@sidebar.layoutSelector).find('.spp-units-display')[0]

        # step knockout
        @stepKO = new (@getDep 'Seed_Options_Form')(this)
        ko.cleanNode @parent.dialog[0]
        ko.applyBindings @stepKO, @parent.dialog[0]

        # KNOCKOUT, STOP SCREWING WITH MY CRAP. SRSLY.
        # re-intialize message_writer because calling ko.cleanNode() breaks it
        @msg = $(@parent.layoutSelector).find('.message_writer').message_writer(autoHide: false, hideTime: 10000)

        @parent.dialog.find('#back_button').on 'click', () =>
            @parent.goToStep(@num - 1)


        # add custom content to the sidebar and initialize it

        ###
        Each button is defined with properties named 'html' and 'click'.

        For convention's sake, if you are defining exactly one button (e.g.
        Burrus), then use ".customButton" and simply create the button object:

        @customButton =
            'html': '<button class="btn btn-blue"><i class="fa fa-file-o"></i> Placement Summary Report</button>'
            'click': () =>
                layers = @curStep.stepKO.plantingPlans()
                @actionPdf(layers)

        If you are defining multiple buttons (e.g. Legend), then use
        ".customButtons", and create an array of button objects:

        @customButtons = [
            {
                'html': '<button class="btn btn-primary pull-left">
                        <i class="fa fa-file-o"></i> Summary Report
                    </button>'
                'click': () =>
                    layers = @curStep.stepKO.plantingPlans()
                    @actionPdf(layers)
            }
            {
                'html': '<button class="btn btn-blue pull-right">
                        <i class="fa fa-chevron-right"></i> Place Order
                    </button>'
                'click': () =>
                    orderLines = []
                    for v,k in @curStep.selectionsKO.hybrids()
                        orderLines.push
                            product:    v.productID
                            tmt:        v.treatmentID
                            qty:        v.units

                    # create the Legend Orders handler
                    order = @curStep.createSubHandler 'Grower.Legend_Orders_Dialog_Handler'
                    if order
                        order.data =
                            lines: orderLines
                        order.init()
            }
        ]

        (Technically, ".customButton" and ".customButtons" are interchangeable,
        because it is both better practice and easier to do that way, but the
        convention exists to make your code clearer. Also, you could put a
        single button in an array if you really wanted to, but that would be
        kind of pointless.)
        ###

        # make sure we don't have stuff being added multiple times
        $('.spp-custom-content').empty()

        customButtons = @parent.customButtons ? @parent.customButton
        if customButtons?
            if customButtons not instanceof Array
                customButtons = [ customButtons ]

            for customButton in customButtons
                $(customButton.html).on('click', customButton.click).appendTo('.spp-custom-content')

            @showCustomButtons()
            @selectionsKO.hybrids.subscribe (hybrids) =>
                @showCustomButtons()


        # processing bars
        if not @parent.makes_recommendations or (@parent.finished and not @parent.inputChanged)
            # if we're just loading existing results, don't show the progress bars
            @stepKO.endProcessing()
        else
            # initialize the progressbars to be all animatey!
            progressbars = $('.spp-progress .bar')
            id = 0

            anim = (elem) ->
                if true
                    minBarTime = 500
                    maxBarTime = 1500
                else
                    minBarTime = 0
                    maxBarTime = 0

                len = Math.floor Math.random() * (maxBarTime - minBarTime) + minBarTime
                elem.animate { width: ['100%', 'swing'] }, len, () ->
                    id++
                    if progressbars.eq(id).length > 0
                        anim progressbars.eq id
                    else
                        self.stepKO.doneProcessing true

            anim progressbars.eq 0

        @sidebar.stepListKO.setCurrent @id

        @parent.inputChanged = false


    setupDatatable: () ->
        # Never initialize the ScrollHelper twice on the same table element.
        # Doing so will break Knockout and duplicate all the rows in the table.
        if not $('.spp-units-display table').hasClass('dataTable')
            ScrollHelper.make $('#table-units'),
                height: '230'


    showCustomButtons: (hybrids) ->
        if not hybrids? then hybrids = @selectionsKO.hybrids()
        if not @stepKO.processing() and hybrids.length > 0
            $('.spp-custom-content').show()
        else
            $('.spp-custom-content').hide()


    showSkippedFieldsDialog: () ->
        self = this
        spp = @parent

        dlg = @createSubHandler 'core::DialogHandler'
        if dlg
            dlg.init = () ->
                @resizable = false
                @defaultSave = false
                @layoutUrl = 'backend/grower/placement/spp/load-skipped-fields-layout'
                @loadLayoutPostOptions =
                    id: spp.sppID
                @classes = 'small_dialog'

                @submitAction = () ->
                    self.stepKO.goToFirstSkippedField()
                    @destroy()

                @createDialog()

            dlg.afterLoadLayout = () ->
                @dialog.find('.cancel-btn').on 'click', () ->
                    self.stepKO.finishSPP()

                @openDialog()

            dlg.init()


    showFinishedDialog: () ->
        dlg = @createSubHandler 'core::DialogHandler'
        if dlg
            spp = @parent

            dlg.init = () ->
                @resizable = false
                @defaultSave = false
                @layoutUrl = 'backend/grower/placement/spp/load-finished-layout'
                @loadLayoutPostOptions =
                    id: spp.sppID
                @classes = 'small_dialog'

                @submitAction = () ->
                    spp.parent.refresh()
                    @destroy() # this is probably unnecessary

                @createDialog()

            dlg.afterLoadLayout = () ->
                @openDialog()

            dlg.init()


    applyFieldsAspects: () ->
        #stub to override default, which was screwing up fields taffy
        return

    updateFieldsAspects: () ->
        #stub to override default, which was screwing up fields taffy
        return

    destroy: () ->
        # console.log 'Exterminate!   Exterminate!'
        $('.spp-units-display').hide()
        $('.spp-units-display #tbody-units').empty()
        $('.spp-custom-content').empty()
        $('#reset_survey_button').removeClass('btn-primary')
        $(window).off('spp.planting-plan-saved')
        $(window).off('spp.planting-plans-copied')
        super()
